
  <div class="log" style="padding-top:130px;">
    <div class="input-cont">
      <h2 stlye="text-align-left prox" style="font-family: 'proxima-nova'; " >Sign in</h2>
    </div>
    <div class="authBlock">
      
      <div class="input-cont formGroup">
        <input type="text"  #email required class="formControl" placeholder="Email address" style="font-size: 16px;">
        <!-- <label>Email address</label> -->
        <div class="border1"></div>
      </div>
      <div class="input-cont formGroup">
        <input type="password" #password required class="formControl" placeholder="Password" style="font-size: 16px;" >
        <!-- <label>Password</label> -->
        <div class="border2"></div>
      </div>
      <div style="height: 32px;"></div>
      <div class="input-cont formGroup">
      <button type="button" style="font-family: 'proxima-nova';" class="button btn-lg btn-block" (click)="auth.SignIn(email.value, password.value)">Sign In</button>
      </div>
      <div (click)="move()" routeActive class="text-center">Create a new account</div>
    </div>
  </div>

